// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__4vhK6","title":"Info_title__1txpp","links":"Info_links__3AtYG","link":"Info_link__2UF6r","logo":"Info_logo__zg5HN"};